var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LoadingButton',{attrs:{"variant":_vm.variant,"busy":_vm.busy,"disabled":_vm.disabled || _vm.busy},on:{"click":_vm.onClick}},[_vm._t("default",function(){return [_vm._v("Delete")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }